/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as InvoicesRouteImport } from './routes/invoices'
import { Route as IndexRouteImport } from './routes/index'
import { Route as InvoicesIndexRouteImport } from './routes/invoices.index'
import { Route as InvoicesIdRouteImport } from './routes/invoices.$id'

const InvoicesRoute = InvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const InvoicesIndexRoute = InvoicesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => InvoicesRoute,
} as any)
const InvoicesIdRoute = InvoicesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => InvoicesRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/invoices': typeof InvoicesRouteWithChildren
  '/invoices/$id': typeof InvoicesIdRoute
  '/invoices/': typeof InvoicesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/invoices/$id': typeof InvoicesIdRoute
  '/invoices': typeof InvoicesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/invoices': typeof InvoicesRouteWithChildren
  '/invoices/$id': typeof InvoicesIdRoute
  '/invoices/': typeof InvoicesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/invoices' | '/invoices/$id' | '/invoices/'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/invoices/$id' | '/invoices'
  id: '__root__' | '/' | '/invoices' | '/invoices/$id' | '/invoices/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  InvoicesRoute: typeof InvoicesRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/invoices': {
      id: '/invoices'
      path: '/invoices'
      fullPath: '/invoices'
      preLoaderRoute: typeof InvoicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices/': {
      id: '/invoices/'
      path: '/'
      fullPath: '/invoices/'
      preLoaderRoute: typeof InvoicesIndexRouteImport
      parentRoute: typeof InvoicesRoute
    }
    '/invoices/$id': {
      id: '/invoices/$id'
      path: '/$id'
      fullPath: '/invoices/$id'
      preLoaderRoute: typeof InvoicesIdRouteImport
      parentRoute: typeof InvoicesRoute
    }
  }
}

interface InvoicesRouteChildren {
  InvoicesIdRoute: typeof InvoicesIdRoute
  InvoicesIndexRoute: typeof InvoicesIndexRoute
}

const InvoicesRouteChildren: InvoicesRouteChildren = {
  InvoicesIdRoute: InvoicesIdRoute,
  InvoicesIndexRoute: InvoicesIndexRoute,
}

const InvoicesRouteWithChildren = InvoicesRoute._addFileChildren(
  InvoicesRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  InvoicesRoute: InvoicesRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
